import { createFileRoute } from '@tanstack/react-router'

import { OptOutsScreen } from './-components/opt-outs-screen.tsx'

export const Route = createFileRoute('/cs-tools/opt-outs')({
  component: OptOutsScreen
})
